/* eslint-disable @typescript-eslint/no-explicit-any */
import React, { useEffect } from 'react';
import { useAppDispatch } from '../../../infra/hooks';
import { commonServices } from '../../../api/services/commonServices';
import { setWorkflowLoader } from '../../../infra/aggregates/workflowLoaderSlice';
interface PropsValue {
  setWorkflowData: (data: any) => void;
  setPendingWith: (data: any) => void;
  instanceId: number;
}

function DTOVerticalBar({
  setWorkflowData,
  instanceId,
  setPendingWith,
}: PropsValue) {
  const dispatch = useAppDispatch();
  async function getWorkflowData(instance: number) {
    dispatch(setWorkflowLoader(true));
    await commonServices.getWorkflow(instance).then((response: any) => {
      if (response) {
        dispatch(setWorkflowLoader(false));
        setWorkflowData(response?.data);
      }
    });
  }
  async function getWorkflowPendingWith(instance: number) {
    dispatch(setWorkflowLoader(true));
    await commonServices.getPendingWorkflow(instance).then((response: any) => {
      if (response) {
        setPendingWith(response?.data);
        dispatch(setWorkflowLoader(false));
      }
    });
  }
  useEffect(() => {
    if (instanceId) {
      getWorkflowData(instanceId);
      getWorkflowPendingWith(instanceId);
    }
  }, [instanceId]);

  return <></>;
}
export default DTOVerticalBar;
